<template>
  <AuthLayout>
    <Invite />
  </AuthLayout>
</template>

<script>
  import AuthLayout from '../layouts/Auth';
  import Invite from '../containers/auth/Invite';

  export default {
    name: 'InvitePage',
    components: { AuthLayout, Invite },
  };
</script>
